<template>
  <section class="has-text-centered column">
    <div>
      <span class="has-text-weight-bold">
        Registra al cliente {{ document }} para que pueda acceder al beneficio
      </span>
      <hr />
      <div class="">
        <Button class="mr-4" variant="gray" @click.native="goBack">
          Volver al Inicio
        </Button>
        <Button variant="main" @click.native="registerSegment">
          Registrar
        </Button>
      </div>
    </div>
  </section>
</template>

<script>
import Button from "@/components/form/Button";
import ValidateService from "@/services/validador/ValidateService";
export default {
  components: {
    Button
  },
  props: {
    document: String,
    company_provider: Number
  },
  methods: {
    goBack() {
      this.$emit("goBack", 0);
    },
    async registerSegment() {
      this.isLoading = true;
      try {
        await ValidateService.putRegisterSegment({
          num_document: this.document,
          company_provider: this.company_provider
        });
        this.$emit("goBack", 4);
      } catch (error) {
        this.$store.commit("settings/SET_ALERT", {
          isAlert: true,
          alertType: "danger",
          alertMessage: "Error al registrar el segmento"
        });
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>
